export const DELETE_DOCUMENT_REQUEST = 'DELETE_DOCUMENT_REQUEST';

export const deleteDocumentRequest = ( id ) => ({
    type: DELETE_DOCUMENT_REQUEST,
    payload: { id }
});
